import styled from 'styled-components';

/* eslint-disable-next-line */
export interface FeaturesStandaloneUiProps {}

const StyledFeaturesStandaloneUi = styled.div`
  color: pink;
`;

export function FeaturesStandaloneUi(props: FeaturesStandaloneUiProps) {
  return (
    <StyledFeaturesStandaloneUi>
      <h1>Welcome to FeaturesStandaloneUi!</h1>
    </StyledFeaturesStandaloneUi>
  );
}

export default FeaturesStandaloneUi;
